import { z } from "zod";

export const ZContacts = z.object({
  nombre: z.string(),
  apellido: z.string(),
  email: z.string(),
  fuente: z.string().optional(),
  referente_nombre: z.string().optional(),
  referente_apellido: z.string().optional(),
});

